import React from 'react';
import SkinResultGenericLayoutSetting from './SkinResultGenericLayoutSetting';
import GetSkinResultGeneralSetting from './GetSkinResultGeneralSetting';
import TabSec from './TabSec';

export default function GenericLayoutSettings({
  formikProps,
  device,
  setDevice,
  defaultCardCategory,
  transformedCategories,
  displayRecommendLayout,
  tab = 'SmbSkincareResultPage',
  setTab,
}) {
  const tabBody = () => {
    if (tab === 'SmbSkincareResultPage') {
      return (
        <SkinResultGenericLayoutSetting
          formikProps={formikProps}
          device={device}
          setDevice={setDevice}
          defaultCardCategory={defaultCardCategory}
          transformedCategories={transformedCategories}
          displayRecommendLayout={displayRecommendLayout}
        />
      );
    }
    return <GetSkinResultGeneralSetting formikProps={formikProps} />;
  };
  return (
    <div>
      <TabSec tab={tab} setTab={setTab} />
      {tabBody()}
    </div>
  );
}
